import React from 'react';

interface AssignmentTypeSelectorProps {
  assignmentType: string;
  onChange: (event: any) => void;
}

const AssignmentTypeSelector: React.FC<AssignmentTypeSelectorProps> = ({
  assignmentType,
  onChange,
}) => {
  return (
    <select id="assignment_type" value={assignmentType} onChange={onChange}>
      <option value="Default">Reading</option>
      <option value="Writing">Writing</option>
      <option value="Read-Aloud">Listening</option>
      <option value="Speaking">Speaking Evaluation</option>
      <option value="Listening">Listening Evaluation</option>
    </select>
  );
};

export default AssignmentTypeSelector;
